import styled from "@emotion/styled";
import { Footer } from "@mantine/core";

export const StyledFooter = styled(Footer)`
  display: flex;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
`;
